import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const faqs = [
  {
    q: "Do I need prior financial knowledge?",
    a: "No — sessions are built for complete beginners as much as for people who want to go deeper.",
  },
  {
    q: "What's the difference between 1:1 and group sessions?",
    a: "The 1:1 is fully personalized to your situation in 30 minutes. The group session covers shared fundamentals with room for individual questions.",
  },
  {
    q: "Can you speak at my school, college or organization?",
    a: "Yes — the general awareness talk is designed exactly for that. Fill the form and mention your audience size and goals.",
  },
  {
    q: "Are the sessions online or in person?",
    a: "1:1 and group sessions are conducted over video or call. Awareness talks can be arranged both online and on-site depending on your event.",
  },
  {
    q: "Will my details be shared?",
    a: "Never. Your details are only used to schedule your session and will never be shared with anyone.",
  },
];

const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="bg-[#F4F1EA] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent md:text-sm">
            Frequently Asked
          </p>
          <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-primary md:text-6xl">
            Questions, answered.
          </h2>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-primary/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left font-display text-xl font-medium text-primary hover:no-underline md:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base font-light leading-relaxed text-foreground/75 md:text-lg">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FAQSection;
